import React, { useEffect } from 'react';
import { H } from 'highlight.run';
import { useGetCurrentUserQuery } from '../generated/graphql';

export const HighlightUserIdentifier: React.FC = () => {
    const { data: currentUserData, loading, error } = useGetCurrentUserQuery();

    useEffect(() => {
        // Only identify users if not running on localhost (development mode)
        const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (isLocalDevelopment) {
            console.log('Highlight.io tracking disabled in development mode');
            return;
        }

        if (currentUserData?.currentUser && !loading && !error) {
            const user = currentUserData.currentUser;

            // Identify the user with highlight.io using their name and other info
            H.identify(`user-${user.id}`, {
                id: user.id,
                name: user.name || 'Unknown User',
                email: user.userName, // userName appears to be the email
                isAdmin: user.isAdminUser,
            });

            console.log('Identified user with Highlight:', {
                id: user.id,
                name: user.name,
                email: user.userName
            });
        }
    }, [currentUserData, loading, error]);

    // This component doesn't render anything, it just handles user identification
    return null;
};
